"use client";

import { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function Slider() {
  const [slides, setSlides] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/slides`)
      .then((response) => setSlides(response.data))
      .catch((error) => console.error("Error fetching slides:", error));
  }, []);

  if (slides.length === 0)
    return <p className="text-center py-8">Loading slides...</p>;

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrentIndex((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <div
      className="position-relative w-100"
      style={{ height: "397px", overflow: "hidden" }}
    >
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`position-absolute top-0 start-0 w-100 h-100 transition-opacity ${
            index === currentIndex ? "opacity-100 z-1" : "opacity-0 z-0"
          }`}
          style={{
            backgroundImage: `url(${process.env.REACT_APP_API_URL}${slide.background_image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100%",
          }}
        >
          <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
            {slide.slide_type === "text" ? (
              <div className="text-center px-2 w-100 container">
                {slide.title && (
                  <h2 className="text-lime-green mb-4 text-shadow font-noto-bold">
                    {slide.title}
                  </h2>
                )}

                {slide.description && (
                  <p className="lead text-primary mb-4 text-shadow font-noto-thin">
                    {slide.description}
                  </p>
                )}

                {slide.button_text && slide.button_link && (
                  <a
                    href={slide.button_link}
                    className="btn btn-inchworm font-roboto rounded-pill btn-lg shadow px-4 fw-bold"
                  >
                    {slide.button_text}
                  </a>
                )}
              </div>
            ) : (
              <div className="container px-4">
                <div className="row row-cols-1 row-cols-md-3 g-4">
                  {slide.cards?.map((card, idx) => (
                    <div key={idx} className="col">
                      <div className="card h-100 shadow bg-white bg-opacity-75">
                        {card.image && (
                          <img
                            src={`${process.env.REACT_APP_API_URL}/${card.image}`}
                            className="card-img-top"
                            alt={card.card_title}
                            style={{ objectFit: "cover", height: "200px" }}
                          />
                        )}
                        <div className="card-body">
                          <h2 className="card-title fw-bold fs-4 text-lime-green text-center">
                            {card.title}
                          </h2>
                          <p className="card-text font-noto-thin text-center">
                            {card.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}

      {/* Navigation buttons */}
      <button
        onClick={prevSlide}
        className="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-2 shadow d-none d-md-block"
        aria-label="Previous slide"
        style={{ zIndex: 2 }}
      >
        <i className="bi bi-arrow-left fs-4 text-dark"></i>
      </button>
      <button
        onClick={nextSlide}
        className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-2 shadow d-none d-md-block"
        aria-label="Next slide"
        style={{ zIndex: 2 }}
      >
        <i className="bi bi-arrow-right fs-4 text-dark"></i>
      </button>

      {/* Mobile indicators */}
      <div
        className="position-absolute bottom-0 start-50 translate-middle-x mb-3 d-flex d-md-none"
        style={{ zIndex: 2 }}
      >
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`btn btn-sm mx-1 rounded-circle p-2 ${
              index === currentIndex ? "btn-primary" : "btn-secondary"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
